import React from 'react';
import ReactDOM from 'react-dom';
import LandingPage from '../pages/LandingPage';
import "../../less/app.less";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Provider } from 'react-redux';
import store from '../redux/store';
import { PrivateRoute } from './PrivateRoute';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';
import Home from '../pages/Home';
import Dashboard from '../pages/Dashboard';
import Reports from '../pages/Reports';
import PlatformUsersManagement from '../pages/PlatformUsersManagement';
import AccountConfig from '../pages/AccountConfig';
import Cashier from '../pages/Cashier';
import { ConfigProvider } from 'antd';
import Couverture from '../pages/Couverture';
import Consultations from '../pages/Consultations';
import Departments from '../pages/Departments';
import Companies from '../pages/Companies';
import Laboratoire from '../pages/Laboratoire';
import CompanyReports from '../pages/CompanyReports';
import PatientPage from '../pages/PatientPage';
import Imagerie from '../pages/Imagerie';
import Facturation from '../pages/Facturation';
import Pharmacie from '../pages/Pharmacie';
import Laser from '../pages/Laser';
import Chirurgie from '../pages/Chirurgie';
import Lunetterie from '../pages/Lunetterie';
import Consommable from '../pages/Consommable';
import Scanner from '../pages/Scanner';
import Irm from '../pages/Irm';
import Radiologie from '../pages/Radiologie';
import Echographie from '../pages/Echographie';
import Cardiologie from '../pages/Cardiologie';
import Mammographie from '../pages/Mammographie';
import Dental from '../pages/Dental';
import Attendance from '../pages/Attendance';
import Hr from '../pages/Hr';
import Neurology from '../pages/Neurology';
import ScanMedicalCheck from '../pages/ScanMedicalCheck';
import ScanDrugPrescription from '../pages/ScanDrugPrescription';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function App() {
  return /*#__PURE__*/_jsx(ConfigProvider, {
    theme: {
      token: {
        colorPrimary: '#223C50',
        colorLink: '#A5A6A9'
      }
    },
    children: /*#__PURE__*/_jsx(Router, {
      children: /*#__PURE__*/_jsxs(Routes, {
        children: [/*#__PURE__*/_jsx(Route, {
          exact: true,
          path: "/",
          element: /*#__PURE__*/_jsx(PrivateRoute, {
            children: /*#__PURE__*/_jsx(LandingPage, {})
          })
        }), /*#__PURE__*/_jsx(Route, {
          path: "/bonjour",
          element: /*#__PURE__*/_jsx(LandingPage, {})
        }), /*#__PURE__*/_jsx(Route, {
          path: "/company/:company_id",
          element: /*#__PURE__*/_jsx(CompanyReports, {})
        }), /*#__PURE__*/_jsx(Route, {
          path: "/insurance/:insurance_id",
          element: /*#__PURE__*/_jsx(CompanyReports, {})
        }), /*#__PURE__*/_jsxs(Route, {
          path: "home",
          element: /*#__PURE__*/_jsx(Home, {}),
          children: [/*#__PURE__*/_jsx(Route, {
            path: "/home",
            element: /*#__PURE__*/_jsx(Dashboard, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "/home/:userid",
            element: /*#__PURE__*/_jsx(Dashboard, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "patient/:pid",
            element: /*#__PURE__*/_jsx(PatientPage, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "dashboard",
            element: /*#__PURE__*/_jsx(Dashboard, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "cashier",
            element: /*#__PURE__*/_jsx(Cashier, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "attendance",
            element: /*#__PURE__*/_jsx(Attendance, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "pharmacie",
            element: /*#__PURE__*/_jsx(Pharmacie, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "lunetterie",
            element: /*#__PURE__*/_jsx(Lunetterie, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "laser",
            element: /*#__PURE__*/_jsx(Laser, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "chirurgie",
            element: /*#__PURE__*/_jsx(Chirurgie, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "hr",
            element: /*#__PURE__*/_jsx(Hr, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "scanner",
            element: /*#__PURE__*/_jsx(Scanner, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "irm",
            element: /*#__PURE__*/_jsx(Irm, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "radiologie",
            element: /*#__PURE__*/_jsx(Radiologie, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "echographie",
            element: /*#__PURE__*/_jsx(Echographie, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "cardiologie",
            element: /*#__PURE__*/_jsx(Cardiologie, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "mammographie",
            element: /*#__PURE__*/_jsx(Mammographie, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "dental",
            element: /*#__PURE__*/_jsx(Dental, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "neuro",
            element: /*#__PURE__*/_jsx(Neurology, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "consultations",
            element: /*#__PURE__*/_jsx(Consultations, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "laboratoire",
            element: /*#__PURE__*/_jsx(Laboratoire, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "facturation",
            element: /*#__PURE__*/_jsx(Facturation, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "imagerie",
            element: /*#__PURE__*/_jsx(Imagerie, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "departments",
            element: /*#__PURE__*/_jsx(Departments, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "consumables",
            element: /*#__PURE__*/_jsx(Consommable, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "companies",
            element: /*#__PURE__*/_jsx(Companies, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "couverture",
            element: /*#__PURE__*/_jsx(Couverture, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "accountconfig",
            element: /*#__PURE__*/_jsx(AccountConfig, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "reports",
            element: /*#__PURE__*/_jsx(Reports, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "users",
            element: /*#__PURE__*/_jsx(PlatformUsersManagement, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "checkmcheck/:id",
            element: /*#__PURE__*/_jsx(ScanMedicalCheck, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "checkdrugprescription/:id",
            element: /*#__PURE__*/_jsx(ScanDrugPrescription, {})
          })]
        })]
      })
    })
  });
}
export default App;
if (document.getElementById('app')) {
  ReactDOM.render(/*#__PURE__*/_jsx(Provider, {
    store: store,
    children: /*#__PURE__*/_jsx(App, {})
  }), document.getElementById('app'));
}